const getSolicitacoes = (state) => {
  return state.solicitacoes
}

const getStatusFilter = (state) => {
  return state.filter
}

const getStatus = (state) => {
  return state.status
}

const getFiles = (state) => {
  return state.files
}

const getHistorics = (state) => {
  return state.historics
}

const getReasons = (state) => {
  return state.reasons
}

const getEmpreendimentos = (state) => {
  return state.empreendimentos
}

const getEmpreendimentosUser = (state) => {
  return state.empreendimentosUser
}

const getServices = (state) => {
  return state.services
}

const getTotalSolicitation = (state) => {
  return state.totalSolicitacoes
}

const getFilteredSolicitationsTyped = (state) => {
  return state.getFilteredSolicitationsTyped
}

const getClicked = (state) => {
  return state.clicked
}

const getPagination = (state) => {
  return state.pagination
}

const getAltCancPagination = (state) => {
  return state.altCancPagination
}

const getShowDeadline = (state) => {
  return state.showDeadline
}

const getNumeroIdDiretriz = (state) => {
  return state.numeroIdDiretriz
}

const getAddressHistoric = (state) => {
  return state.addressHistoric
}

const getFilesHasChanges = (state) => {
  return state.filesHasChanges
}

const getAltCancelAproveGrant = (state) => {
  return state.hasAltCancelAproveGrant
}

const getPendingAltCancelList = (state) => {
  return state.pendingAltCancelHists
}

const getPendingAltCancCommentDetails = (state) => {
  return state.pendingAltCancCommentDetails
}

const getPendingRequestAltCanc = (state) => {
  return state.isPendingRequestAltCanc
}

export default {
  getSolicitacoes,
  getStatusFilter,
  getFiles,
  getHistorics,
  getReasons,
  getEmpreendimentos,
  getEmpreendimentosUser,
  getServices,
  getTotalSolicitation,
  getFilteredSolicitationsTyped,
  getStatus,
  getClicked,
  getPagination,
  getShowDeadline,
  getNumeroIdDiretriz,
  getAddressHistoric,
  getFilesHasChanges,
  getAltCancelAproveGrant,
  getPendingAltCancelList,
  getPendingAltCancCommentDetails,
  getAltCancPagination,
  getPendingRequestAltCanc
}
